import { SquarePenIcon, TrashIcon } from 'lucide-react';
import { Group } from '@/lib/api/groups';
import { Popconfirm } from '@/components/Popconfirm';
import { useTranslation } from 'react-i18next';

export interface ActionsProps {
  group: Group;
  onEdit: (group: Group) => void;
  onDelete: (group: Group) => void;
  isLoading?: boolean;
}

export function Actions({ group, onEdit, onDelete, isLoading }: ActionsProps) {
  const { t } = useTranslation();

  return (
    <div className="gap-2xs flex items-center">
      <Popconfirm
        onConfirm={() => onDelete(group)}
        title={t('groups.table.deleteAction.title')}
        description={t('groups.table.deleteAction.description')}
        variant="danger"
        confirmLabel={t('groups.table.deleteAction.label')}
      >
        <button
          type="button"
          className="text-neutral-muted hover:text-error-default outline-neutral-subtle cursor-pointer rounded-full transition-all focus:outline-2 focus:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
          disabled={isLoading}
        >
          <TrashIcon size={16} />
        </button>
      </Popconfirm>
      <button
        type="button"
        className="text-neutral-muted hover:text-neutral-default outline-neutral-subtle cursor-pointer rounded-full transition-all focus:outline-2 focus:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        onClick={() => onEdit(group)}
        disabled={isLoading}
      >
        <SquarePenIcon size={16} />
      </button>
    </div>
  );
}
